<template>
  <a
    @click="click"
    class="logo"
    :class="themeClasses('logo')"
  ><img
      :src="`/api/companys/me/images/${logo0}`"
      v-if="logo0"
      @error="logo0 = ''"
      class="logo-black"
    >
    <span
      v-else
      class="font--27px"
    >{{company.companyName}} LOGO</span>
    <img
      :src="`/api/companys/me/images/${logo1}`"
      v-if="logo1"
      @error="logo1 = ''"
      class="logo-white"
    >
    <!-- <span v-else>{{company.companyName}}</span> -->
  </a>
</template>

<script>

import { mapState } from 'vuex'
import theme from '@/component/js/theme'

export default {
  mixins: [theme],
  props: {
    // reverse: { type: Boolean, default: false }
  },
  data () {
    return {
      logo0: 'logo0',
      logo1: 'logo1'
    }
  },
  computed: {
    ...mapState(['company'])
    // logo0 () {
    //   return ''
    //   // const index = 0
    //   // return this.company && this.company.logos.length > index && this.company.logos[index].fileName
    // },
    // logo1 () {
    //   return 'logo1'
    //   // const index = 1
    //   // //  this.reverse ? 1 : 0
    //   // return this.company && this.company.logos.length > index && this.company.logos[index].fileName
    // }
  },
  methods: {
    onError (err) {
      console.log('-=---------=', err)
    },
    click () {
      if (this.$route.name.startsWith('admin')) {
        this.$router.push({ name: 'adminMain' })
      } else {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>
